import AuthQuote from "@components/auth/auth.quote";
import AuthLogo from "@components/auth/auth.logo";
import ResetPasswordForm from "./reset.password.form";
import Error404 from "@/components/404";

const ResetPasswordContainer = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  if (!token) return <Error404 />;
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      <div className="w-full h-full bg-gray-100 p-10 lg:p-20">
        <div className="mx-auto max-w-sm">
          <AuthLogo />
          <h3 className="font-bold text-black text-center text-2xl">Create New Password</h3>

          <div className="text-center text-sm mb-5 px-10 text-black">Enter your new password below</div>
          <ResetPasswordForm token={token} />
        </div>
      </div>
      <AuthQuote />
    </div>
  );
};

export default ResetPasswordContainer;
